import { googleMapsKey } from '../constants';

export async function locationFromPostal(element){
    const   {default: MapsLoader} = await import('load-google-maps-api'),
			Maps = await MapsLoader({
				v: '3.30',
				key: googleMapsKey,
				libraries: ['places']
			}),
            geo = new Maps.Geocoder();
    let key = element.getAttribute('location-from-postal'),
        /** @type {HTMLInputElement} */ 
        country = document.querySelector(`[name="${key}Country"]`),
        /** @type {HTMLInputElement} */ 
        postal = document.querySelector(`[name="${key}ZipCode"]`),
        /** @type {HTMLInputElement} */ 
        city = document.querySelector(`[name="${key}City"]`),
        /** @type {HTMLInputElement} */ 
        state = document.querySelector(`[name="${key}State"]`);
    [country,postal].forEach(element => element.addEventListener('change',() => {
        
        let countryVal = country.value.toString(), 
            postalCode = postal.value.toString();
        return countryVal && postalCode ? 
            geo.geocode( {componentRestrictions:{ country:countryVal, postalCode }}, (results, status) => {
                if(status === 'OK'){
                    let [{address_components}] = results;

                    city.value = (address_components.find( ({types}) => types.indexOf('locality') !== -1) || {}).short_name,
                    state.value = (address_components.find( ({types}) => types.indexOf('administrative_area_level_1') !== -1) || {}).short_name;
                }
            }) : false;
    }));
}